import React from 'react';
import {connect} from 'react-redux';

import {BaseRate, mapStateToProps} from './BaseRate.jsx';

import {addCouponRate as addCouponRateAction, addRate as addRateAction} from 'actions/creators/CouponRate';
import {makeBet as makeBetAction} from 'actions/creators/MakeBet';
import {requestBetTypes as requestBetTypesAction} from 'actions/creators/HistoryBet';

import {getRateDisplayValue} from 'rendering-commons';

class HeaderRate extends BaseRate {
    constructor(props) {
        super(props);
    }

    render() {
        const {rate, isInCoupon, outcomeIsBlocked} = this.props;

        if (rate === undefined) {
            return false;
        }

        const isVisible = rate.get('isVisible');
        const rateValue = isVisible
            ? getRateDisplayValue(rate.get('value'))
            : '\u00A0';

        let cls = 'cell rate';

        if (rate.get('isBlocked') || outcomeIsBlocked || !isVisible) {
            cls += ' closed';
        } else if (isInCoupon) {
            cls += '--in-coupon';
        }

        const props = {
            key: rate.get('id'),
            ref: "rate",
            className: cls
        };

        if (rate.get('isVisible')) {
            props.onClick = this._onClick;
        }

        return (
            <span {...props}>{rateValue}</span>
        );
    }
}

export default connect(mapStateToProps, {
    addCouponRateAction, makeBetAction, requestBetTypesAction, addRateAction
}, null, false)(HeaderRate);



// WEBPACK FOOTER //
// ./js/sport-betting/components/grid-control/components/rates/HeaderRate.jsx